import React, { useState } from "react";
import { FaCaretRight, FaSearch } from "react-icons/fa";
import "./index.css";

const SearchFilters = ({
  parameters,
  selectedFilters,
  setSelectedFilters,
  handleResetFilters,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showResults, setShowResults] = useState(false);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setShowResults(value !== "");
  };

  const handleSelectFilter = (filterId) => {
    const selectedFilter = parameters.find((filter) => filter.id === filterId);
    const filterLabel = selectedFilter.label;

    // Verificar si el filtro ya está seleccionado
    const filterIndex = selectedFilters.findIndex(
      (filter) => filter.id === filterId
    );

    if (filterIndex !== -1) {
      // Actualizar filtro existente
      const updatedFilters = [...selectedFilters];
      updatedFilters[filterIndex] = { id: filterId, label: filterLabel, searchTerm };
      setSelectedFilters(updatedFilters);
    } else {
      // Agregar nuevo filtro
      setSelectedFilters([...selectedFilters, { id: filterId, label: filterLabel, searchTerm }]);
    }

    setShowResults(false);
    setSearchTerm("");
  };

  const handleRemoveFilter = (filterId) => {
    const updatedFilters = selectedFilters.filter((filter) => filter.id !== filterId);
    setSelectedFilters(updatedFilters);
  };

  return (
    <div className="search-filters">
      <div className="search-filters-inputs">
        <div className="search-input-container">
          <div className="search-icon-container">
            <FaSearch className="search-icon" />
          </div>
          <input
            className="search-filters-input"
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={handleSearch}
            onFocus={() => setShowResults(true)}
          />
        </div>

        {selectedFilters.length > 0 && (
          <div className="ml-2 text-under-ref">
            <small onClick={handleResetFilters}>Borrar Filtros</small>
          </div>
        )}
      </div>

      {/* Filtros seleccionados como tags */}
      <div className="selected-filters">
        {selectedFilters.map((filter) => (
          <div key={filter.id} className="selected-filter">
            <div style={{ fontSize: "12px", fontWeight: "bold" }}>{filter.label}</div>
            <div>{filter.searchTerm}</div>
            <button
              type="button"
              className="btn btn-sm"
              style={{
                position: "absolute",
                top: "-5px",
                right: "0",
                color: "white",
                background: "red",
                padding: "0 5px",
                borderRadius: "50px",
              }}
              onClick={() => handleRemoveFilter(filter.id)}
            >
              &times;
            </button>
          </div>
        ))}
      </div>

      {/* Resultados de búsqueda */}
      {showResults && (
        <ul className="search-filters-results">
          {parameters.map((filter) => (
            <li key={filter.id} onClick={() => handleSelectFilter(filter.id)}>
              <FaCaretRight />{" "}
              <span style={{ fontStyle: "italic", textDecoration: "underline" }}>
                {filter.label}
              </span>{" "}
              : <strong>{searchTerm}</strong>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchFilters;